import { RootAction, CRMState } from '..';


export const initialState: CRMState = {
  placeholder: '',
};

export default function crm(state = initialState, action: RootAction): typeof initialState {
  return state;
}